// extracted by mini-css-extract-plugin
export default {"sup_container":"Supplies_sup_container__SVXRp","suppliesContainer":"Supplies_suppliesContainer__BKE+d"};